import { render, staticRenderFns } from "./ReservasList.vue?vue&type=template&id=4f00c17d&"
import script from "./ReservasList.vue?vue&type=script&lang=js&"
export * from "./ReservasList.vue?vue&type=script&lang=js&"
import style0 from "./ReservasList.vue?vue&type=style&index=0&id=4f00c17d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports